import { render } from "./AddGroupAndMemberPage.vue?vue&type=template&id=0394dfae&ts=true"
import script from "./AddGroupAndMemberPage.vue?vue&type=script&lang=ts"
export * from "./AddGroupAndMemberPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__